import React from 'react'
import ContentReport from './content-report'
import { Grid, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useStyles } from './style'
import { useTenantFormContext } from '../tenant-form-context'
import { TenantEditSlice } from '../../../reducers'
import UsersReport from './users-report'
import AccelerateReport from './accelerate-report'
import { CONSTANTS } from '../../../util/constants'

const getTenantFeatures = features => {
  return {
    hasContentHub: Object.hasOwn(features, 'contentHub') ? features.contentHub : true,
    hasSkillBites: features?.skillBite?.enabled,
    hasMSA: features?.assessment?.enabled ?? features?.msa ?? false,
    hasAccelerate: features?.accelerate?.enabled ?? false
  }
}

const ReportsTab = () => {
  const classes = useStyles()
  const { mainClasses } = useTenantFormContext()
  const tenant = useSelector(TenantEditSlice.selectors.tenant)
  const { features } = tenant
  const { hasContentHub, hasSkillBites, hasMSA, hasAccelerate } = getTenantFeatures(features)

  const template = useSelector(TenantEditSlice.selectors.tenantTemplate)
  const isClub = tenant.pk === CONSTANTS.DEFAULT_CLUB_PK
  const hasUsersReport = hasContentHub || hasSkillBites || hasMSA

  return (
    <Grid container className={classes.root} gap={2}>
      <Grid container alignItems='center' className={mainClasses.ctnTitle}>
        <Grid item xs={9}>
          <Typography variant='h6' gutterBottom>Reports</Typography>
        </Grid>
      </Grid>
      {hasContentHub && <ContentReport tenantId={tenant.pk} templateName={template.name} />}
      {(!isClub && hasUsersReport) && <UsersReport tenantId={tenant.pk} />}
      {(!isClub && hasAccelerate) && <AccelerateReport tenantId={tenant.pk} />}
    </Grid>

  )
}

export default ReportsTab
